import { useState, useEffect } from 'react'

import { LiaPepperHotSolid } from "react-icons/lia";
import { AiFillFileAdd } from "react-icons/ai";
import { FaFaceLaugh } from "react-icons/fa6";
import { BiSolidUserRectangle } from "react-icons/bi";
import { PiTextTFill } from "react-icons/pi";
import { FaDice } from "react-icons/fa";
import { FaCloud } from "react-icons/fa";
import { PiImageBrokenDuotone } from "react-icons/pi";
import { FiUser } from 'react-icons/fi';
import { FaPlus } from 'react-icons/fa';


const CloudWithW = ({ size = 40, color = "#333" }) => {
    return (
        // 1. Container: Relative to anchor the absolute elements inside
        <div style={{ position: 'relative', display: 'inline-flex', justifyContent: 'center', alignItems: 'center' }}>

            <FaCloud size={size} color={color} />

            <span style={{
                position: 'absolute',
                color: 'white',
                fontSize: size * 0.4, // Adjust font size relative to icon size
                fontWeight: 'bold',
                fontFamily: 'sans-serif',

                // Centering Trick: Move to 50% of container, then move back 50% of self
                top: '50%',
                left: '50%',
                transform: 'translate(-60%, -40%)',

                // Optional: SVG icons sometimes have visual weight differences, 
                // you might need a slight manual nudge (e.g., marginTop: '5px')
                pointerEvents: 'none' // Ensures clicks pass through to the icon behind
            }}>
                W
            </span>
        </div>
    );
};

export const ProfileWithAdd = ({ size = 40, color = "#333" }) => {
    return (
        <div style={{ 
            position: 'relative',
            display: 'inline-flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: size,
            height: size,
            borderRadius: '50%',
            backgroundColor: '#e2e8fa', // Light blue background
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        }}>
            <FiUser 
                size={size * 0.7} 
                color={color}
                style={{ transform: 'translateY(-3%)' }} // Fine-tune positioning
            />

            <FaPlus 
                size={size * 0.4} 
                color="white"
                fontWeight="bold"
                style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    pointerEvents: 'none'
                }}
            />
        </div>
    );
};


export default function Icons( props )
{
    const type = props.type 
    const style = (props.style) ? props.style : {}

    if( type == "basic-image" )
    {
        return <AiFillFileAdd style={{ ...style }} />
    }
    
    if( type == "basic-text" )
    {
        return <PiTextTFill style={{ ...style }} />
    }

    if( type == "basic-avatar" )
    {
        return <BiSolidUserRectangle style={{ ...style }} />
    }

    if( type == "basic-emoticon")
    {
        return <FaFaceLaugh style={{ ...style }}  />
    }

    if( type == "misc-random-picker" )
    {
        return <FaDice style={{ ...style }} />
    }

    if( type == "misc-word-cloud" )
    {
        return <CloudWithW style={{ ...style }} />
    }

    if( type == "misc-tug-of-war" )
    {
        return <CloudWithW style={{ ...style }} />
    }

    return <PiImageBrokenDuotone style={{ ...style }}/>
}
